import * as z from "zod";
import { mutator } from "./mutator";

export const exportPersonalChat = mutator({
  schema: z.object({
    id: z.string(),
  }),
  resolve: {},
  permissions: {
    none: "records that the caller exported a chat they could see",
  },
  description:
    "Triggered when a user downloads a personal chat as a JSON file.",
  interactionType: "create",
  fn: async () => {},
});
